import React from 'react'
import PropTypes from 'prop-types'
import Avatar from 'shared/components/common/Avatar/Avatar.component'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './Active.module.scss'

const ActiveWrapper = createDivAtom(),
      AgentName = createDivAtom()

const Active = ({ agent }) => (
  <ActiveWrapper
    className={styles.wrapper}
  >
    <Avatar
      subject={{ name: agent?.name }}
      size='smaller'
    />

    <AgentName
      className={styles.agentName}
    >
      {agent?.name}
    </AgentName>
  </ActiveWrapper>
)


Active.propTypes = {
  agent: PropTypes.object.isRequired
}

export default Active
